import { KiziLogger, useField } from '@kizi/comparator-core';
import { Div } from '@kizi/core-components';
import React, { useEffect, useState } from 'react';
import { FormFieldHOCProps } from '.';
import { Select } from './wrappers/inputs/withFormField';
import { SelectOption, SelectProps } from './wrappers/inputs/withFormProps';

export interface SelectWithAPIWrapperProps
  extends FormFieldHOCProps,
    SelectProps {
  manipulateData?: Function;
  optionsFieldName: string;
  requestUrl?: RequestInfo;
  requestProps?: RequestInit;
  value?: string;
  warningTextForIds?: string[];
}

export const SelectWithApiWrapper: React.FC<SelectWithAPIWrapperProps> = ({
  manipulateData = (data: any) => {
    return data;
  },
  options,
  optionsFieldName,
  requestUrl,
  requestProps,
  warningTextForIds,
  ...restProps
}) => {
  const currentOption = useField(restProps._fieldName);
  const storedOptions = useField(optionsFieldName);

  if (!currentOption || !storedOptions) return null;
  const { value = '' } = currentOption;

  const storedOptionsValue: SelectOption[] =
    Object.prototype.hasOwnProperty.call(storedOptions, 'value') &&
    storedOptions?.value !== undefined
      ? JSON.parse(storedOptions.value as string)
      : [];

  const [_options, setOptions] = useState<SelectOption[]>(storedOptionsValue);

  useEffect(() => {
    if (!_options.length && requestUrl && requestProps) {
      fetch(requestUrl, requestProps)
        .then((response) => response.json())
        .then(({ data }) => {
          const cleanData = [...options, ...manipulateData(data)];
          setOptions(cleanData);
          storedOptions?.set({
            value: JSON.stringify(cleanData),
          });
        })
        .catch((error) => {
          KiziLogger.logError({
            eventId: 0,
            member: 'SelectWithApiWrapper',
            message: 'Error in fetchData',
            eventName: 'fetchDataError',
            data: {
              error,

              variables: {
                requestUrl,
                requestProps,
              },
            },
          });
        });
    }
  }, []);

  return (
    <Div>
      <Select
        {...{ ...restProps, options: _options }}
        value={value as string}
      />
    </Div>
  );
};
